var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmazonLinux2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F7981F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.879 61.843a3.003 3.003 0 0 0 3.002 3.002h27.436a3.003 3.003 0 0 0 3.002-3.002V33.738a3.002 3.002 0 0 0-3.002-3.002H33.881a3.003 3.003 0 0 0-3.002 3.002v28.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.232 31.124a3.003 3.003 0 0 1 3.002-3.002H51.8v-7.145a3.002 3.002 0 0 0-3.001-3.002H21.365a3.002 3.002 0 0 0-3.002 3.002v28.104a3.002 3.002 0 0 0 3.002 3.002h6.867V31.124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.87 18.427a3.002 3.002 0 0 1 3.002-3.002h20.566V8.28a3.003 3.003 0 0 0-3.002-3.002H9.002A3.002 3.002 0 0 0 6 8.28v28.105a3.003 3.003 0 0 0 3.002 3.002h6.868v-20.96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonLinux2);
export default __webpack_public_path__ + "static/media/amazon-linux-2.6ff4a99ec9868479b0a16c2807b63b44.svg";
export { ForwardRef as ReactComponent };